import { add, qsa, listen } from '@fluorescent/dom';

const classes = {
  contrast: 'section--contrast',
  parentContrast: 'shopify-section--contrast',
  parentContrastBeforeFooter: 'shoping-section--contrast-before-footer',
  logoList: 'logo-list',
  parentLogoList: 'shopify-section--logo-list',
  hidden: 'hidden',
};

export default () => {
  function adjustClasses() {
    const sections = qsa('.main .shopify-section');
    sections.forEach((section, index) => {
      const { firstElementChild: child } = section;

      // Add contrast class to all parents of contrast sections
      if (child && child.classList.contains(classes.contrast)) {
        add(section, classes.parentContrast);

        // Add spacing class if last section is a contrast section
        if (index === sections.length - 1) {
          add(section, classes.parentContrastBeforeFooter);
        }
      }

      // Add logo list class to all parents of logo lists
      if (child && child.classList.contains(classes.logoList)) {
        add(section, classes.parentLogoList);
      }

      // Specific to recommended hidden products
      if (child && child.classList.contains(classes.hidden)) {
        add(section, classes.hidden);
      }
    });
  }

  adjustClasses();
  listen(document, 'shopify:section:load', adjustClasses);
};
